// Generated by ReScript, PLEASE EDIT WITH CARE


var phoneNumberRegexUae = /^0?(?:50|51|52|54|55|56|58)\d{7}$/;

var phoneNumberRegexBd = /^0?1[3456789]\d{8}$/;

var phoneNumberRegexTr = /^(?:\+90|0090|0)?5\d{9}$/;

var hasAtleastOneAlphabetRegex = /\w*[a-zA-Z]\w*/;

var hasParamsRegex = /.*\?{1}.+/;

var nameRegex = /[^a-zA-Z\s]+/;

export {
  phoneNumberRegexUae ,
  phoneNumberRegexBd ,
  phoneNumberRegexTr ,
  hasAtleastOneAlphabetRegex ,
  hasParamsRegex ,
  nameRegex ,
}
/* No side effect */
